<template>
  <div class="checkout-summary checkout-summary-size">
    <div class="cart-summary-box">
      <div>
        <table class="summary-cart rounded-br-none rounded-bl-none">
          <thead>
          <tr class="font-bold">
            <th class="text-black opacity-100" colspan="3">
              <div class="flex">
                <div class="w-2/4 lg:w-full xl:w-full">
                 <h3 class="text-center" >Zusammenfassung </h3>
                </div>
              </div>
            </th>
          </tr>
          <tr >
            <th>Artikel</th>
            <th>Menge</th>
            <th>Preis</th>
          </tr>
          </thead>
        </table>
        <div class="overscroll-wrapper">
          <table class="summary-cart rounded-br-none rounded-bl-none">
            <tbody>
            <tr v-for="item in order.orderItems.data" >
              <td>{{ item.name }}</td>
              <td>{{ getTextFromUnit(item.unit) }}</td>
              <td>{{ getOrderPrice(item.price, order.shop) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <table>
          <tbody>
          <tr>
            <td colspan="2">Zwischensumme <span>(inkl. MwSt)</span></td>
            <td>{{ getOrderPrice(order.products_price, order.shop) }}</td>
          </tr>
          <tr class="light-color">
            <td colspan="2">Versand & Verpackung ({{ getCarrierText() }})</td>
            <td>{{ getOrderPrice(order.shipping_cost, order.shop) }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td colspan="2">Insgesamt</td>
            <td>{{ getOrderPrice(order.total, order.shop) }}</td>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'orderSummary',
    props: {},
    data () {
      return {
      }
    },
    mixins: [formatting],
    methods: {
      ...mapActions([
      ]),
      getCarrierText () {
        return this.carrier.name
      }
    },
    computed: {
      ...mapGetters({
        order: 'checkout_get_order',
        loading: 'options_is_loading',
        deliveryAddress: 'checkout_get_order_address',
        invoiceAddress: 'checkout_get_order_invoice_address',
        paymentMethod: 'checkout_get_order_paymentMethod',
        carrier: 'checkout_get_order_carrier'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/orderSummary.vue